import styled from '@emotion/styled';
import { H4 } from 'ds/components/typography';


export const SubsectionHeader = styled(H4)`
  ${({ theme }) => `
    margin: 0 ${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)};
    color: ${theme.colors.neutrals.grey3};
  `}
`;
